var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg100Edit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.29 2.28994C16.6822 1.89782 17.3179 1.89782 17.71 2.28994L21.71 6.28994C21.8993 6.47771 22.0058 6.7333 22.0058 6.99994C22.0058 7.26658 21.8993 7.52217 21.71 7.70994C21.5223 7.89925 21.2667 8.00574 21 8.00574C20.7334 8.00574 20.4778 7.89925 20.29 7.70994L16.29 3.70994C15.8979 3.31782 15.8979 2.68206 16.29 2.28994ZM3.00002 21.9999H7.00002C7.26582 22.0015 7.5213 21.8971 7.71002 21.7099L19.71 9.70994C19.8993 9.52217 20.0058 9.26658 20.0058 8.99994C20.0058 8.7333 19.8993 8.47771 19.71 8.28994L15.71 4.28994C15.5223 4.10063 15.2667 3.99414 15 3.99414C14.7334 3.99414 14.4778 4.10063 14.29 4.28994L2.29002 16.2899C2.10283 16.4787 1.99848 16.7341 2.00002 16.9999V20.9999C2.00002 21.5522 2.44773 21.9999 3.00002 21.9999ZM4.00002 17.4099L15 6.40994L17.59 8.99994L6.59002 19.9999H4.00002V17.4099Z",
    fill: "#8199A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg100Edit);
export default __webpack_public_path__ + "static/media/100-edit.18ef56d1bc6676dd1f98ab8485f55d30.svg";
export { ForwardRef as ReactComponent };